// removed by extract-text-webpack-plugin
module.exports = {"tooltip":"_2RdzSJLK0qSAHjkP","icon":"_1WVRXk0GTbeLcrHN","iconHover":"_3IMv7qW7J0vVAvsr","content":"_2fPOhDaiQ0WgxZUV"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Common/Tooltip.pcss
// module id = 481
// module chunks = 1